import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from "@app/core/authentication/authentication.service";
import { ConstantService } from '../../shared/services/constant.service';
import { SnackService } from '../../shared/services/extra/snack.service';

@Injectable()
export class AuthGuard  {
    constructor(
        private _authService: AuthenticationService,
        private _constService: ConstantService,
        private _snack: SnackService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        const admin = localStorage.getItem("isTypeAdmin");
        if (this._authService.isAuthenticated && admin === "true") {
            // productionadmin stays limited to Issues/Settings; supportadmin has full access.
            if (this._constService._isHardware) {
                return this.deny(state.url);
            }
            return true;
        } else {
            return this.deny(state.url);
        }
    }

    // Access rules are unchanged; this only tells the user why nothing happened.
    private deny(url: string): boolean {
        const type = this._constService.permissionType;
        if (!this._authService.isAuthenticated) {
            this._snack.displayError(`Please log in to open ${url}.`);
        } else if (!type) {
            this._snack.displayError('Your Roots profile is still loading or could not be loaded. Please refresh.');
        } else {
            this._snack.displayError(`Your account type "${type}" does not have access to ${url}. Contact a Roots admin.`);
        }
        return false;
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        return this.canActivate(childRoute, state);
    }
}
